import { useLocation } from "react-router-dom";

const SITE_URL = "https://terreetmer-conciergerie.fr";
const SITE_NAME = "TERRE ET MER CONCIERGERIE";
const DEFAULT_OG_IMAGE =
  "https://images.unsplash.com/photo-1646489346674-b8640e514453?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxzYWludCUyMG1hbG8lMjBicmV0YWduZXxlbnwwfHx8fDE3Nzc4NDM1NDJ8MA&ixlib=rb-4.1.0&q=85&w=1200";

/**
 * SEO component leveraging React 19's native metadata hoisting.
 * Renders <title>, meta tags, canonical link & JSON-LD structured data.
 */
const SEO = ({
  title,
  description,
  keywords,
  image = DEFAULT_OG_IMAGE,
  type = "website",
  noindex = false,
  jsonLd = null,
  breadcrumbs = null,
}) => {
  const location = useLocation();
  const canonical = `${SITE_URL}${location.pathname}`;
  const fullTitle = title.includes(SITE_NAME)
    ? title
    : `${title} | ${SITE_NAME}`;

  const breadcrumbLd = breadcrumbs
    ? {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs.map((b, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: b.name,
          item: `${SITE_URL}${b.path}`,
        })),
      }
    : null;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta
        name="robots"
        content={
          noindex
            ? "noindex, nofollow"
            : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        }
      />
      <meta name="googlebot" content={noindex ? "noindex" : "index, follow"} />
      <link rel="canonical" href={canonical} />
      <meta httpEquiv="Content-Language" content="fr" />
      <meta name="language" content="French" />
      <meta name="geo.region" content="FR-BRE" />
      <meta name="geo.placename" content="Bretagne, Côte d'Émeraude" />
      <meta name="author" content={SITE_NAME} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={title} />

      {/* JSON-LD structured data */}
      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      )}
      {breadcrumbLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbLd) }}
        />
      )}
    </>
  );
};

export default SEO;
export { SITE_URL, SITE_NAME };
